import type { SummaryResult } from '@chewy/audio-to-notes-ui'

export interface SummaryContext {
  correlationId: string
  currentAppointmentId: string | null
  isOnSoapPage: boolean
  pathname: string
  summariesFTEnabled: boolean
}

export type SummaryDestination =
  | { type: 'discard' }
  | {
      appointmentId: string
      summaries: SummaryResult[]
      type: 'queued'
    }
  | {
      summaries: SummaryResult[]
      type: 'inject'
    }

/**
 * Determines where summaries should be delivered based on context.
 * Pure function - no React hooks, easy to test.
 *
 * @param summaries - Summary results from library
 * @param context - Context from useSummaryContext hook + correlationId
 * @returns Destination type and associated data
 */
export const determineSummaryDestination = (
  summaries: SummaryResult[],
  context: SummaryContext,
): SummaryDestination => {
  // FT disabled - discard summaries silently
  if (!context.summariesFTEnabled) {
    return { type: 'discard' }
  }

  if (!context.isOnSoapPage) {
    // Not on SOAP page - mutation will still run, but show toast instead of injecting
    return {
      type: 'queued',
      appointmentId: context.correlationId,
      summaries,
    }
  }

  // On SOAP page - mutation runs and CKEditor syncs via Redux
  return {
    type: 'inject',
    summaries,
  }
}
